import React, { useEffect, useState, useRef } from 'react';
import { Button, message, MessageBox, Tooltip } from 'kenshin';
import TablePro from '@/components/TablePro';
import { connect } from 'umi';
import ModalFormPro from '@/components/ModalFormPro';
import { btnKeys } from '@/_util/keysType'; // 假设用到按钮权限key，如果没有可以去掉

const ProjectType = ({ dispatch, loading, project }) => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editModalData, setEditModalData] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  useEffect(() => {
    dispatch({ type: 'project/getProjectTypeTree' });
  }, []);

  const modalRef = useRef({});

  const showEditModal = (row) => {
    setEditModalVisible(true);
    setEditModalData({
      ...row,
    });
  };

  const delRole = (row) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认删除？删除后无法恢复',
      onOk: () => {
        dispatch({
          type: 'project/deleteProjectType',
          payload: {
            typeId: row.typeId,
          },
        }).then((res) => {
          if (res) {
            message.success('删除成功');
          }
        });
      },
    });
  };

  const editModalSave = (value) => {
    let payload = {
      ...value,
    };
    let hasEdit = false;

    if (editModalData?._type === 'edit') {
      hasEdit = true;
      payload.typeId = editModalData.typeId;
      // 如果是编辑，且是第二层，可能需要传父级ID，视接口要求而定，这里先只传基本信息
      // 如果接口需要parentId，从editModalData取
      if (editModalData.parentId) {
        payload.typePid = editModalData.parentId;
      }
    } else {
      // 新增
      // 如果是从某一行点击新增，说明是增加子级
      if (editModalData && editModalData.typeId) {
        payload.typePid = editModalData.typeId;
      } else {
        // 顶层新增
        payload.typePid = 0;
      }
    }

    dispatch({ type: 'project/editProjectType', hasEdit, payload }).then(
      (res) => {
        if (res) {
          setEditModalData(null);
          setEditModalVisible(false);
          message.success('操作成功');
        }
      },
    );
  };

  const columns = [
    {
      dataIndex: 'typeName',
      title: '类型名称',
    },
    {
      dataIndex: 'typeRemark',
      title: '类型描述',
      width: 300,
      render: (val) => (
        <Tooltip overlayStyle={{ maxWidth: 400 }} title={val}>
          <div className="ellipsis-text" style={{ width: 300 }}>
            {val}{' '}
          </div>
        </Tooltip>
      ),
    },
    {
      title: '操作',
      width: 150,
      key: 'options',
      render: (row) => {
        if (!row) return;
        return (
          <>
            {(row.typePid == 1 || row.typeId == 1) && (
              <Button
                type="text"
                onClick={() =>
                  showEditModal({
                    ...row,
                    _type: 'add',
                  })
                }
              >
                新增
              </Button>
            )}
            {row.typeId != 1 && (
              <Button
                type="text"
                onClick={() =>
                  showEditModal({
                    ...row,
                    _type: 'edit',
                  })
                }
              >
                编辑
              </Button>
            )}
            {row.typeId != 1 && (
              <Button
                type="text"
                style={{ color: 'red' }}
                onClick={() => delRole(row)}
              >
                删除
              </Button>
            )}
          </>
        );
      },
    },
  ];

  const edtaFormItem = [
    {
      label: '类型名称',
      name: 'typeName',
      type: 'Input',
      required: '请输入类型名称',
      props: {
        placeholder: '请输入类型名称',
      },
    },
    {
      label: '类型描述',
      name: 'typeRemark',
      type: 'TextArea',
      props: {
        placeholder: '请输入类型描述',
      },
    },
  ];

  const onExpandedRowsChange = (keys) => {
    setExpandedRowKeys(keys);
  };

  const extra = () => (
    <Button type="primary" onClick={() => showEditModal({ _type: 'add' })}>
      新增类型
    </Button>
  );

  return (
    <div>
      <TablePro
        request="project/getProjectTypeTree"
        rowKey="typeId"
        columns={columns}
        dataSource={[project.projectTypeList]}
        childrenColumnName="child"
        curColumns
        expandable={{ expandedRowKeys, onExpandedRowsChange }}
        pagination={false}
      />

      <ModalFormPro
        width={600}
        visible={editModalVisible}
        edtaFormItem={edtaFormItem}
        formData={editModalData?._type === 'edit' ? editModalData : {}}
        onSave={editModalSave}
        ref={modalRef}
        onCancel={() => {
          setEditModalData(null);
          setEditModalVisible(false);
        }}
      />
    </div>
  );
};

export default connect(({ project, loading }) => {
  return { project, loading: loading.effects['project/getProjectTypeTree'] };
})(ProjectType);
